<div class="qb-sync-page" dir="rtl">
  <header class="qb-sync-header">
    <div>
      <h1>סנכרון QuickBooks</h1>
      <p>סנכרון כל אנשי הקשר והמידע הכספי שלהם לפי הזרימה הקיימת</p>
    </div>
    <span class="status" [attr.data-status]="status?.status || 'idle'">{{ statusLabel(status?.status) }}</span>
  </header>

  <section class="setup" *ngIf="!isActive">
    <form [formGroup]="form">
      <label>
        <span>סנכרון תשלומים מתאריך</span>
        <input type="date" formControlName="minimumPaymentDate">
      </label>
      <mat-slide-toggle formControlName="includeFuturePayments">כלול תשלומים עתידיים</mat-slide-toggle>
      <mat-slide-toggle formControlName="includeNonSuccessfulPayments">כלול תשלומים לא מוצלחים</mat-slide-toggle>
      <button mat-raised-button color="primary" type="button" (click)="start()" [disabled]="loading || form.invalid">
        <mat-icon>sync</mat-icon>
        התחל סנכרון מלא
      </button>
    </form>
  </section>

  <section class="progress-area" *ngIf="status">
    <div class="progress-title">
      <strong>{{ status.processedContacts || 0 }} מתוך {{ status.totalContacts || 0 }}</strong>
      <span>{{ progressPercent }}%</span>
    </div>
    <mat-progress-bar mode="determinate" [value]="progressPercent"></mat-progress-bar>

    <div class="metrics">
      <div><span>הצליחו</span><strong>{{ status.succeededContacts || 0 }}</strong></div>
      <div><span>נכשלו</span><strong>{{ status.failedContacts || 0 }}</strong></div>
      <div><span>תשלומים שלא סונכרנו</span><strong>{{ status.failedPayments || 0 }}</strong></div>
      <div><span>תשלומים שדולגו</span><strong>{{ status.skippedPayments || 0 }}</strong></div>
    </div>

    <div class="current" *ngIf="status.currentContactId">
      <span>איש קשר נוכחי</span>
      <strong>{{ status.currentContactName || 'ללא שם' }} · {{ status.currentContactId }}</strong>
    </div>

    <p class="last-message">{{ status.lastMessage || status.summary }}</p>

    <div class="controls" *ngIf="isActive">
      <button mat-stroked-button type="button" (click)="pause()" [disabled]="!canPause || controlPending">
        <mat-icon>pause</mat-icon> השהה
      </button>
      <button mat-stroked-button type="button" (click)="resume()" [disabled]="!canResume || controlPending">
        <mat-icon>play_arrow</mat-icon> המשך
      </button>
      <button mat-stroked-button color="warn" type="button" (click)="stop()" [disabled]="controlPending">
        <mat-icon>stop</mat-icon> עצור
      </button>
    </div>
  </section>
</div>
